export enum LayoutTypeEnum {
  /** 未登录 */
  ADMIN = 'ADMIN',
  /** 已登录 - 全屏 */
  FULL_SCREEN = 'FULL_SCREEN',
  /** 已登录 - 基础 */
  BASIC = 'BASIC',
}

export enum FeedbackCategoryOptionsEnum {
  BUG_REPORT = 1,
  FEATURE_REQUEST = 2,
  USABILITY_ISSUE = 3,
  VISUAL_PROBLEM = 4,
  QUESTION_HELP = 5,
  OTHERS = 6,
}
